import { authorizedUser } from "components/Common/commonFunctions";
import * as API from "../API/index";

const createUser = async (bodyData) => {
  try {
    const res = await API.create_user(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateUser = async (userId, bodyData) => {
  try {
    const res = await API.update_user(userId, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getUserList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.users_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export { createUser, updateUser, getUserList };

export const validateUrlUuid = async (uuid) => {
  try {
    const res = await API.validate_url_uuid(uuid);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const resetPassword = async (passwordData) => {
  try {
    const res = await API.reset_password(passwordData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getUserDetails = async (userID) => {
  try {
    const res = await API.get_user_details(userID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const userresetPassword = async (userID) => {
  try {
    const res = await API.user_reset_password(userID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const uploadReportingRawCsv = async (formData) => {
  try {
    const res = await API.upload_reporting_raw_csv(formData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getCsvLogList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.get_csv_logs_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const loginAsPublisher = async (loginData) => {
  try {
    const res = await API.user_login_as_publisher(loginData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const userChangePassword = async (passwordData) => {
  try {
    const res = await API.user_change_password(passwordData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const createPublisherUser = async (bodyData) => {
  try {
    const res = await API.create_publisher_user(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublisherUserList = async (pageNum, filters, searchString,   sortField, sortOrder,) => {
  try {
    const res = await API.publisher_users_list(pageNum, filters, searchString,   sortField,  sortOrder,);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublisherUserDetails = async (userID) => {
  try {
    const res = await API.get_publisher_user_details(userID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
